import React, { useState } from 'react';

// Escalate button with an optional comment for the manager.
export function EscalateControl({ onEscalate, label = 'Escalate', buttonClass }: {
  onEscalate: (reason: string) => void;
  label?: string;
  buttonClass?: string;
}) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} className={buttonClass ?? 'text-xs font-medium text-[#2563EB] whitespace-nowrap'}>
        {label}
      </button>
    );
  }
  return (
    <form
      onSubmit={e => { e.preventDefault(); onEscalate(reason.trim()); setOpen(false); setReason(''); }}
      className="inline-flex items-center gap-1.5"
    >
      <input
        autoFocus value={reason} onChange={e => setReason(e.target.value)}
        placeholder="Add a comment (optional)"
        className="w-56 px-2 py-1 rounded-md border border-trim text-xs text-ink outline-none focus:border-teal-400"
      />
      <button type="submit" className="text-xs font-semibold text-white bg-[#063F5A] rounded-md px-2 py-1">Escalate</button>
      <button type="button" onClick={() => { setOpen(false); setReason(''); }} className="text-xs text-muted px-1">Cancel</button>
    </form>
  );
}
